import * as React from "react";
import { createRoot } from "react-dom/client";
import { Routes, Route, useLocation } from "react-router-dom";

import { HeaderNav } from "./components/HeaderNav";
import { MantineProvider } from "@mantine/core";
import { NotFoundPage } from "./components/NotFoundPage";
import { RootRedirectPage } from "./components/RootRedirectPage";
// import { AboutPage } from "./pages/about/AboutPage";

// import { HomePage } from "./pages/home/HomePage";
// import { AllReleasesPage } from "./pages/samples/AllReleasesPage";
// import ReleaseDetailPage from "./pages/samples/ReleaseDetailPage";
// import { ShortRunPage } from "./pages/shortrun/ShortRunPage";
import { Mac2026Page } from "./pages/mac-2026/Mac2026Page";
// import { ShortRun2026Page } from "./pages/shortrun-2026/ShortRun2026Page";
import { LAZineFest2026Page } from "./pages/la-zine-fest-2026/LAZineFest2026Page";
import { DallasZineFest2026Page } from "./pages/dallas-zine-fest-2026/DallasZineFest2026Page";
// import { PressPlay2025Page } from "./pages/pressplay2025/PressPlay2025Page";
// import { SeattleArtBookFair2026Page } from "./pages/seattle-art-book-fair-2026/SeattleArtBookFair2026Page";
// import { DallasArtBookFair2026Page } from "./pages/dallas-art-book-fair-2026/DallasArtBookFair2026Page";
// import { BrooklynArtBookFair2026Page } from "./pages/brooklyn-art-book-fair-2026/BrooklynArtBookFair2026Page";
// import { BayAreaBookFestivalPage } from "./pages/bay-area-book-festival/BayAreaBookFestivalPage";
// import { SFArtBookFair2026Page } from "./pages/sf-art-book-fair-2026/SFArtBookFair2026Page";
// import { NYArtBookFair2026Page } from "./pages/ny-art-book-fair-2026/NYArtBookFair2026Page";
// import { SFZineFest2026Page } from "./pages/sf-zine-fest-2026/SFZineFest2026Page";
// import { CALA2026Page } from "./pages/cala-2026/CALA2026Page";

function AppRoutes() {
  const location = useLocation();
  const isRoot = location.pathname === "/";
  const hideHeader =
    isRoot ||
    location.pathname === "/mac-2026" ||
    location.pathname === "/la-zine-fest-2026" ||
    location.pathname === "/dallas-zine-fest-2026";

  return (
    <>
      {!hideHeader && <HeaderNav />}

      <Routes>
        <Route path="/" element={<RootRedirectPage />} />
        {/* <Route path="shortrun-2025" element={<ShortRunPage />} /> */}
        <Route path="mac-2026" element={<Mac2026Page />} />
        {/* <Route path="shortrun2026" element={<ShortRun2026Page />} /> */}
        <Route path="la-zine-fest-2026" element={<LAZineFest2026Page />} />
        <Route path="dallas-zine-fest-2026" element={<DallasZineFest2026Page />} />
        {/* <Route path="pressplay-2025" element={<PressPlay2025Page />} /> */}
        {/* <Route path="ebabz" element={<PressPlay2025Page />} /> */}
        {/* <Route path="seattle-art-book-fair-2026" element={<SeattleArtBookFair2026Page />} /> */}
        {/* <Route path="dallas-art-book-fair-2026" element={<DallasArtBookFair2026Page />} /> */}
        {/* <Route path="brooklyn-art-book-fair-2026" element={<BrooklynArtBookFair2026Page />} /> */}
        {/* <Route path="bay-area-book-festival" element={<BayAreaBookFestivalPage />} /> */}
        {/* <Route path="sf-art-book-fair-2026" element={<SFArtBookFair2026Page />} /> */}
        {/* <Route path="ny-art-book-fair-2026" element={<NYArtBookFair2026Page />} /> */}
        {/* <Route path="sf-zine-fest-2026" element={<SFZineFest2026Page />} /> */}
        {/* <Route path="cala-2026" element={<CALA2026Page />} /> */}

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <>
      <MantineProvider
        theme={{
          fontFamily: "IBM Plex Mono, monospace",
          fontFamilyMonospace: "IBM Plex Mono, monospace",
          headings: { 
            fontFamily: "Nanum Myeongjo, serif",
            sizes: {
              h1: { fontSize: '2.25rem' },  // 1.5x default
              h2: { fontSize: '1.8rem' },   // 1.5x default
              h3: { fontSize: '1.5rem' },   // 1.5x default
              h4: { fontSize: '1.2rem' },   // 1.5x default
              h5: { fontSize: '1.05rem' },  // 1.5x default
              h6: { fontSize: '0.9rem' },   // 1.5x default
            },
          },
          // colors: {
          //   brand: ["#144eff", "#144eff", "#144eff", "#144eff", "#144eff", "#144eff", "#144eff", "#144eff", "#144eff", "#144eff"],
          // },
          // primaryColor: "brand",
        }}
        // children={undefined}
      >
        <AppRoutes />
      </MantineProvider>
    </>
  );
}

export function renderToDom(container) {
  createRoot(container).render(<App />);
}
